import { useAuth0 } from '@auth0/auth0-react';
import { PropsWithChildren, useEffect } from 'react';
import { Stack, CircularProgress, Typography } from '@mui/material';
import { NotAuthorized } from '@/components/not-authorized';

const LoadingPage = () => (
  <Stack justifyContent="center" alignItems="center" height="100vh">
    <CircularProgress size={50} thickness={5} />
    <Typography variant="h5">Validando sesión...</Typography>
  </Stack>
);

export const AuthRequired = (props: PropsWithChildren) => {
  const authHooks = useAuth0();

  useEffect(() => {
    if (!authHooks.isAuthenticated && !authHooks.isLoading && !authHooks.error) {
      authHooks.loginWithRedirect({
        appState: {
          returnTo: window.location.pathname,
        },
      });
    }
  }, [
    authHooks.isAuthenticated,
    authHooks.error,
    authHooks.isLoading,
    authHooks.loginWithRedirect,
  ]);

  if (
    authHooks.isLoading ||
    (!authHooks.isAuthenticated && !authHooks.isLoading && !authHooks.error)
  ) {
    return <LoadingPage />;
  }

  if (authHooks.error) {
    return <NotAuthorized />;
  }

  return props.children;
};
